export interface Conference {
	id: number;
	title: string;
	subtitle: string;
	description: string;
	image: string;
	features: string[];
	topics: string[];
}

export interface UpcomingEvent {
	date: string;
	title: string;
	location: string;
	time: string;
}

export const conferences: Conference[] = [
	{
		id: 1,
		title: "Ponencia Escénica",
		subtitle: "Todo lo que no ves - Una conferencia artística",
		description:
			"Una conferencia artística que integra literatura, danza y audiovisuales para explorar el mito romántico de la familia, las heridas invisibles de la infancia y los vínculos afectivos saludables.",
		image: "/assets/todo-lo-que-no-ves/a-1-main.jpeg",
		features: [
			"Integra literatura, danza y audiovisuales",
			"50-60 minutos de duración adaptable",
			"Espacio de preguntas y coloquio",
			"Dirigido a público general",
		],
		topics: [
			"Infancia y educación emocional",
			"Prevención de violencia de género",
			"Vínculos familiares saludables",
			"Transformación social a través del arte",
		],
	},
	{
		id: 2,
		title: "Talleres Especializados",
		subtitle: "Matrices de aprendizaje y comunicación familiar",
		description:
			"Talleres experienciales para familias que buscan sensibilizar sobre la comunicación, los estilos educativos y la transmisión de patrones familiares.",
		image: "/assets/todo-lo-que-no-ves/a-2-main.jpeg",
		features: [
			"Taller experiencial participativo",
			"1.5-2 horas de duración",
			"Herramientas de comunicación no violenta",
			"Dirigido a familias",
		],
		topics: [
			"Estilos educativos y patrones familiares",
			"Comunicación no violenta",
			"Gestión emocional",
			"Parentalidad consciente",
		],
	},
];

export const upcomingEvents: UpcomingEvent[] = [
	{
		date: "25 de Noviembre",
		title:
			"Día Internacional de la Eliminación de la Violencia contra la Mujer",
		location: "Centro Cultural Las Palmas",
		time: "19:00h",
	},
	{
		date: "20 de Diciembre",
		title: "Día Universal del Niño",
		location: "Auditorio Alfredo Kraus",
		time: "18:30h",
	},
];
